<router-outlet></router-outlet>

@if (showCookieBanner) {
	<section class="cookie-banner" aria-live="polite" aria-label="Cookie preferences">
		<h3>Cookies on this site</h3>
		<p>
			We use cookies and similar technologies to operate the website, improve performance,
			and understand usage. You can accept all cookies or reject non-essential cookies.
		</p>

		<div class="cookie-actions">
			<button type="button" class="btn btn-primary" (click)="acceptAllCookies()">Accept all</button>
			<button type="button" class="btn btn-outline-secondary" (click)="rejectNonEssentialCookies()">Reject non-essential</button>
		</div>
	</section>
}
